export class CdcModel {
  id: string;
  cdc_code: string;
}